import { Select, Modal, Button } from "antd";
import { useState } from "react";
import { useUpdateProfile } from "../api/api.update";
import { useAuthContext } from "../providers/auth.provider";

const COUNTRY_SETUP_KEY = "exhut-country-set";

const COUNTRIES = [
  { label: "Afghanistan", value: "AFG" },
  { label: "Albania", value: "ALB" },
  { label: "Algeria", value: "DZA" },
  { label: "Angola", value: "AGO" },
  { label: "Argentina", value: "ARG" },
  { label: "Armenia", value: "ARM" },
  { label: "Australia", value: "AUS" },
  { label: "Austria", value: "AUT" },
  { label: "Azerbaijan", value: "AZE" },
  { label: "Bahrain", value: "BHR" },
  { label: "Bangladesh", value: "BGD" },
  { label: "Belarus", value: "BLR" },
  { label: "Belgium", value: "BEL" },
  { label: "Bolivia", value: "BOL" },
  { label: "Bosnia and Herzegovina", value: "BIH" },
  { label: "Botswana", value: "BWA" },
  { label: "Brazil", value: "BRA" },
  { label: "Bulgaria", value: "BGR" },
  { label: "Cambodia", value: "KHM" },
  { label: "Cameroon", value: "CMR" },
  { label: "Canada", value: "CAN" },
  { label: "Chile", value: "CHL" },
  { label: "China", value: "CHN" },
  { label: "Colombia", value: "COL" },
  { label: "Costa Rica", value: "CRI" },
  { label: "Croatia", value: "HRV" },
  { label: "Cuba", value: "CUB" },
  { label: "Czech Republic", value: "CZE" },
  { label: "Denmark", value: "DNK" },
  { label: "Dominican Republic", value: "DOM" },
  { label: "Ecuador", value: "ECU" },
  { label: "Egypt", value: "EGY" },
  { label: "El Salvador", value: "SLV" },
  { label: "Estonia", value: "EST" },
  { label: "Ethiopia", value: "ETH" },
  { label: "Finland", value: "FIN" },
  { label: "France", value: "FRA" },
  { label: "Georgia", value: "GEO" },
  { label: "Germany", value: "DEU" },
  { label: "Ghana", value: "GHA" },
  { label: "Greece", value: "GRC" },
  { label: "Guatemala", value: "GTM" },
  { label: "Honduras", value: "HND" },
  { label: "Hungary", value: "HUN" },
  { label: "Iceland", value: "ISL" },
  { label: "India", value: "IND" },
  { label: "Indonesia", value: "IDN" },
  { label: "Iran", value: "IRN" },
  { label: "Iraq", value: "IRQ" },
  { label: "Ireland", value: "IRL" },
  { label: "Israel", value: "ISR" },
  { label: "Italy", value: "ITA" },
  { label: "Ivory Coast", value: "CIV" },
  { label: "Jamaica", value: "JAM" },
  { label: "Japan", value: "JPN" },
  { label: "Jordan", value: "JOR" },
  { label: "Kazakhstan", value: "KAZ" },
  { label: "Kenya", value: "KEN" },
  { label: "Kuwait", value: "KWT" },
  { label: "Kyrgyzstan", value: "KGZ" },
  { label: "Laos", value: "LAO" },
  { label: "Latvia", value: "LVA" },
  { label: "Lebanon", value: "LBN" },
  { label: "Libya", value: "LBY" },
  { label: "Lithuania", value: "LTU" },
  { label: "Luxembourg", value: "LUX" },
  { label: "Madagascar", value: "MDG" },
  { label: "Malaysia", value: "MYS" },
  { label: "Mali", value: "MLI" },
  { label: "Mexico", value: "MEX" },
  { label: "Moldova", value: "MDA" },
  { label: "Mongolia", value: "MNG" },
  { label: "Morocco", value: "MAR" },
  { label: "Mozambique", value: "MOZ" },
  { label: "Myanmar", value: "MMR" },
  { label: "Namibia", value: "NAM" },
  { label: "Nepal", value: "NPL" },
  { label: "Netherlands", value: "NLD" },
  { label: "New Zealand", value: "NZL" },
  { label: "Nicaragua", value: "NIC" },
  { label: "Niger", value: "NER" },
  { label: "Nigeria", value: "NGA" },
  { label: "North Korea", value: "PRK" },
  { label: "Norway", value: "NOR" },
  { label: "Oman", value: "OMN" },
  { label: "Pakistan", value: "PAK" },
  { label: "Panama", value: "PAN" },
  { label: "Papua New Guinea", value: "PNG" },
  { label: "Paraguay", value: "PRY" },
  { label: "Peru", value: "PER" },
  { label: "Philippines", value: "PHL" },
  { label: "Poland", value: "POL" },
  { label: "Portugal", value: "PRT" },
  { label: "Qatar", value: "QAT" },
  { label: "Romania", value: "ROU" },
  { label: "Russia", value: "RUS" },
  { label: "Rwanda", value: "RWA" },
  { label: "Saudi Arabia", value: "SAU" },
  { label: "Senegal", value: "SEN" },
  { label: "Serbia", value: "SRB" },
  { label: "Singapore", value: "SGP" },
  { label: "Slovakia", value: "SVK" },
  { label: "Slovenia", value: "SVN" },
  { label: "Somalia", value: "SOM" },
  { label: "South Africa", value: "ZAF" },
  { label: "South Korea", value: "KOR" },
  { label: "South Sudan", value: "SSD" },
  { label: "Spain", value: "ESP" },
  { label: "Sri Lanka", value: "LKA" },
  { label: "Sudan", value: "SDN" },
  { label: "Sweden", value: "SWE" },
  { label: "Switzerland", value: "CHE" },
  { label: "Syria", value: "SYR" },
  { label: "Taiwan", value: "TWN" },
  { label: "Tajikistan", value: "TJK" },
  { label: "Tanzania", value: "TZA" },
  { label: "Thailand", value: "THA" },
  { label: "Tunisia", value: "TUN" },
  { label: "Turkey", value: "TUR" },
  { label: "Turkmenistan", value: "TKM" },
  { label: "Uganda", value: "UGA" },
  { label: "Ukraine", value: "UKR" },
  { label: "United Arab Emirates", value: "ARE" },
  { label: "United Kingdom", value: "UK" },
  { label: "United States", value: "USA" },
  { label: "Uruguay", value: "URY" },
  { label: "Uzbekistan", value: "UZB" },
  { label: "Venezuela", value: "VEN" },
  { label: "Vietnam", value: "VNM" },
  { label: "Yemen", value: "YEM" },
  { label: "Zambia", value: "ZMB" },
  { label: "Zimbabwe", value: "ZWE" },
];

export default function CountrySetupModal() {
  const { user } = useAuthContext();
  const { mutateAsync: updateProfile, isPending } = useUpdateProfile();
  const [selected, setSelected] = useState<string | undefined>(undefined);
  const [open, setOpen] = useState(
    () => !!user && !localStorage.getItem(COUNTRY_SETUP_KEY),
  );

  const isOpen = !!user && open;

  const handleSave = async () => {
    if (!selected) return;
    await updateProfile({ countryCode: selected });
    localStorage.setItem(COUNTRY_SETUP_KEY, "1");
    setOpen(false);
  };

  return (
    <Modal
      open={isOpen}
      title="Where are you based?"
      closable={false}
      maskClosable={false}
      footer={
        <Button
          type="primary"
          disabled={!selected}
          loading={isPending}
          onClick={handleSave}
        >
          Save
        </Button>
      }
    >
      <p className="text-sm text-gray-500 mb-4">
        This helps us show the right currency and settings for your account.
      </p>
      <Select
        showSearch
        placeholder="Select your country"
        style={{ width: "100%" }}
        options={COUNTRIES}
        filterOption={(input, option) =>
          (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
        value={selected}
        onChange={setSelected}
      />
    </Modal>
  );
}
